import { Button, Card } from "antd";
import { CardItemText } from "../CardItemText";
import React from "react";
import "./index.scss";
import Arrow from "../../assets/arrow.svg";
export var CardGridItem = function CardGridItem(_ref) {
  var _ref$hoverable = _ref.hoverable,
      hoverable = _ref$hoverable === void 0 ? false : _ref$hoverable,
      title = _ref.title,
      description = _ref.description,
      secondDescription = _ref.secondDescription,
      buttonText = _ref.buttonText,
      buttonType = _ref.buttonType,
      buttonLink = _ref.buttonLink,
      onClick = _ref.onClick,
      buttonDisabled = _ref.buttonDisabled;
  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Card.Grid, {
    hoverable: hoverable,
    style: gridStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-item-grid-content grid-table",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(CardItemText, {
    title: title,
    description: description,
    secondDescription: secondDescription
  }), buttonText && /*#__PURE__*/React.createElement(Button, {
    type: buttonType,
    disabled: buttonDisabled,
    color: "#4D37FD"
  }, /*#__PURE__*/React.createElement("a", {
    href: buttonLink,
    target: "_blank",
    rel: "noreferrer"
  }, buttonText)), hoverable && /*#__PURE__*/React.createElement("img", {
    src: Arrow,
    style: {
      fontSize: "30px",
      color: "#9a9a9a"
    }
  })));
};